
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useOnboardingContext } from '@/context/OnboardingContext';
import Onboarding from '@/pages/Onboarding';

const OnboardingGuard: React.FC = () => {
  const { isLoading, onboardingComplete } = useOnboardingContext();

  console.log('OnboardingGuard - isLoading:', isLoading, 'onboardingComplete:', onboardingComplete);

  // Show loading while checking onboarding status
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  // If onboarding is complete, redirect to home
  if (onboardingComplete) {
    console.log('OnboardingGuard - User already completed onboarding, redirecting to /home');
    return <Navigate to="/home" replace />;
  }

  // Show onboarding if not completed
  console.log('OnboardingGuard - Showing onboarding page');
  return <Onboarding />;
};

export default OnboardingGuard;
